import { ApiRequestError, type ApiErrorBody } from '@app-types/api';

/** Minimal envelope shared by the summary-api and fundamentals-api responses. */
export interface DataApiEnvelope {
  message?: string;
  reason?: string;
  status: number;
}

const buildDataApiErrorBody = (
  body: DataApiEnvelope | undefined,
  fallbackMessage: string,
): ApiErrorBody => {
  const message = typeof body?.message === 'string' && body.message.trim()
    ? body.message
    : fallbackMessage;
  const reason = typeof body?.reason === 'string' && body.reason.trim()
    ? body.reason
    : undefined;

  return reason ? { message, reason } : { message };
};

/**
 * Raises an `ApiRequestError` for a 2xx response whose envelope reports failure
 * (`status !== 0`) or carries no payload. Shared by every data API module so the
 * backend `message`/`reason` reach the widget notification mapping unchanged.
 */
export const throwDataApiError = (
  body: DataApiEnvelope | undefined,
  status: number | undefined,
  fallbackMessage: string,
): never => {
  const errorBody = buildDataApiErrorBody(body, fallbackMessage);
  throw new ApiRequestError(errorBody.message ?? fallbackMessage, {
    status,
    body: errorBody,
  });
};
